import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store.js'

Vue.use(Router)

let router =  new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            props: (route) => ({ query: route.query.act }),
            // beforeEnter: () => {
            //     window.location.href = 'https://www.myurl.io';
            // }
        },
        {
            path: '/campaign',
            name: 'campaign',
            // route level code-splitting
            // this generates a separate chunk (campaign.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "campaign" */ './views/Campaign.vue')
        },
        {
            path: '/setting',
            name: 'setting',
            // route level code-splitting
            // this generates a separate chunk (campaign.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "campaign" */ './views/Setting.vue')
        },
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
        },
        {
            path: '/detail/:id/:flightid',
            name: 'detail',
            // route level code-splitting
            // this generates a separate chunk (detail.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "detail" */ './views/Detail.vue')
        },
        {
            path: '/report/:id',
            name: 'report',
            // route level code-splitting
            // this generates a separate chunk (report.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "report" */ './views/Report.vue'),
            props: (route) => ({ query: route.query.q })
        },
        {
            path: '/reportfull/:id',
            name: 'reportfull',
            // route level code-splitting
            // this generates a separate chunk (reportfull.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "reportfull" */ './views/ReportFull.vue'),
            props: (route) => ({ query: route.query.q })
        }
        ,
        {
            path: '/login',
            name: 'login',
            //redirect:'https://mobile.innity.com.my/',
            meta: { layout: "no-sidebar" },
            // route level code-splitting
            // this generates a separate chunk (login.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
        },

    ]
})



router.beforeEach((to, from, next) => {
  Vue.config.debug = true;
  
  // console.log('Global -- beforeEach - fired');
  // console.log(store.getters.isLoggedIn)
  const isLoggedIn = store.getters.isLoggedIn
  //const requiresAuth =  to.matched.some(record => record.meta.requiresAuth)
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
 // console.log(authRequired)
  if (authRequired && !isLoggedIn) {
      return next({ 
        path: '/login', 
        //query: { returnUrl: to.path } 
      });
  }

  next();

})

// router. ((to, from, next) => {
//     window.location.href = 'https://www.myurl.io';
// })
export default router